import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import RmvendorquotationInfo from '../RmvendorquotationInfo';


export default function RmvendorquotationListTableRow({obj, getActionComponent,handleRowClick}){
  useEffect(()=>{
  },[])
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" 
          //onClick={() => handleRowClick(obj.id)}
            sx={{
              //cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={6} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.rmvendorname}</Typography></Grid>
              {/* <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid> */}
              {/* <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.rawdemandid}</Typography></Grid> */}
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.quotation}</Typography></Grid>
              {/* <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.rmvendorid}</Typography></Grid> */}
              

              <Grid item lg={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {getActionComponent(obj)}
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        {/* {obj.expand ?
        <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            < RmvendorquotationInfo  rmvendorquotationObj={obj} />
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>} */}
      </>
      
    )
}